"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForecastLocaleProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _i18n = require("@react-aria/i18n");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Custom locale provider to allow overwriting the OS locale with the locale specified by the person's forecast account, saved at the 'userLocale' key in LocalStorage.
 * This is a bit of an anti-pattern since the design-system in theory should be fully independent from the Forecast app, but the injector specified by react-aria does not seem to be able to traverse across libraries.
 */
var ForecastLocaleProvider = function ForecastLocaleProvider(_ref) {
  var children = _ref.children;
  var forecastLocale = localStorage.getItem('userLocale');
  var nativeLocale = (0, _i18n.useLocale)();
  var locale = forecastLocale && forecastLocale !== '' ? forecastLocale : nativeLocale.locale;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.I18nProvider, {
    locale: locale,
    children: children
  });
};
exports.ForecastLocaleProvider = ForecastLocaleProvider;